import React, { useState, useCallback, useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Icon from "../../Icon";
import styles from "./UserBar.module.scss";
import withTheme from "../../../libs/themr/withTheme";

const UserBar = ({
  theme,
  isAuthenticated,
  username,
  handleLogin,
  handleLogout,
  handleViewProfile,
  translate,
  createAccountLink
}) => {
  const [profileVisibility, setProfileVisibility] = useState(false);

  const toggleProfile = useCallback(() => {
    setProfileVisibility(!profileVisibility);
  }, [profileVisibility, setProfileVisibility]);

  const handleDocumentClick = useCallback(() => {
    if (profileVisibility) {
      setProfileVisibility(false);
    }
  }, [profileVisibility, setProfileVisibility]);

  useEffect(() => {
    if (document) {
      document.addEventListener("click", handleDocumentClick);
    }
    return () => {
      if (document) {
        document.removeEventListener("click", handleDocumentClick);
      }
    };
  }, [handleDocumentClick]);

  return (
    <div className={theme.userBar}>
      {isAuthenticated ? (
        <>
          <button type="button" onClick={toggleProfile} className={theme.profileBtn}>
            {username}
            <Icon className={theme.iconArrow} icon="drop-down-arrow" />
          </button>
          <ul className={cx([theme.profileDropdown, { [theme.show]: profileVisibility }])}>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <li onClick={handleViewProfile}>
              <Icon className={theme.logout} icon="view-account-icon" />
              <span>
                {translate && translate("viewAccount")}
                {!translate && "View Account"}
              </span>
            </li>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <li onClick={handleLogout}>
              <Icon className={theme.logout} icon="log-out-icon" />
              <span>
                {translate && translate("logOut")}
                {!translate && "Log Out"}
              </span>
            </li>
          </ul>
        </>
      ) : (
        <button type="button" onClick={handleLogin} className={theme.profileBtn}>
          <Icon className={theme.iconUser} icon="user-bar-icon" />
          {translate && translate("login")}
          {!translate && "Login"}
        </button>
      )}
      {createAccountLink && !isAuthenticated && (
        <a href={createAccountLink} className={styles.createAccountLink}>
          {translate("Create Account")}
        </a>
      )}
    </div>
  );
};

UserBar.defaultProps = {
  isAuthenticated: false,
  username: "",
  translate: text => text,
  createAccountLink: null
};

UserBar.propTypes = {
  username: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  handleLogin: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleViewProfile: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  translate: PropTypes.func,
  createAccountLink: PropTypes.string
};

export default withTheme(styles)(UserBar);
